import { asideTabs, internetPackageEnum, LocalesType, RoadmapDataType } from "../constants/globals";
import { SIGNALING_STATUS } from "../constants/signaling";
import { ClientRoomReport } from "../proto/ClientRoomReport_pb";
import { ClientAction, GroupRoom, MplTransaction, Platform, RegisteredUser, Room, RoomMessageLog, RoomMessageType, RoomMessageWallet } from "../proto/Global_pb";
import { SignalingGetLogResponse } from "../proto/SignalingGetLog_pb";
import { SignalingOffer } from "../proto/SignalingOffer_pb";
import { ConnectionStatusType } from "../store/connection/types";
import { MessengerThemeLayoutType } from "../store/messenger/types";
import { internetPackageTypes } from "../components/popup/internet-packages/reducer";

const fa = {
  recorder: {
    audio_permission_denied: "عدم دسترسی به میکروفون",
    video_permission_denied: "عدم دسترسی به دوربین",
  },
  call_status: {
    [SignalingGetLogResponse.SignalingLog.Status.MISSED]: "ازدست رفته",
    [SignalingGetLogResponse.SignalingLog.Status.CANCELED]: "لغو شده",
    [SignalingGetLogResponse.SignalingLog.Status.INCOMING]: "دریافتی",
    [SignalingGetLogResponse.SignalingLog.Status.OUTGOING]: "خروجی",
  },
  connection: {
    [ConnectionStatusType.DISCONNECTED]: "درحال اتصال",
    [ConnectionStatusType.CONNECTED]: "درحال ایمن سازی",
    [ConnectionStatusType.SECURED]: "درحال احراز هویت",
    [ConnectionStatusType.LOGGED_IN]: "",
  },
  chats: {
    is_typing: "در حال نوشتن...",
    action: {
      [ClientAction.TYPING]: "در حال نوشتن...",
      [ClientAction.SENDING_IMAGE]: "در حال ارسال عکس...",
      [ClientAction.SENDING_FILE]: "در حال ارسال فایل...",
    },
    participantsCount: "تعداد اعضاء : {{count}}",
    edited: "ویرایش شده",
    clear_cache: "بازسازی با سرور",
    clear_history: "پاک کردن تاریخچه",
    delete_chat: "حذف چت",
    draft: "پیش نویس",
    left_room: "ترک کردن",
    join: "عضویت",
    start: "شروع",
    isAdmin: "مدیر",
    role: {
      [GroupRoom.Role["ADMIN"]]: "مدیر",
      [GroupRoom.Role["MEMBER"]]: "اعضا",
      [GroupRoom.Role["MODERATOR"]]: "ناظر",
      [GroupRoom.Role["OWNER"]]: "سازنده",
    },
    lastSeen: {
      [RegisteredUser.Status.LONG_TIME_AGO]: "خیلی وقت پیش",
      [RegisteredUser.Status.LAST_MONTH]: "یک ماه پیش",
      [RegisteredUser.Status.LAST_WEEK]: "یک هفته پیش",
      [RegisteredUser.Status.ONLINE]: "آنلاین",
      [RegisteredUser.Status.EXACTLY]: "",
      [RegisteredUser.Status.RECENTLY]: "چند لحظه پیش",
      [RegisteredUser.Status.SUPPORT]: "پشتیبانی",
      [RegisteredUser.Status.SERVICE_NOTIFICATIONS]: "سرویس اطلاع رسانی",
    },
    settings: {
      chat_room: "اتاق پیام",
      font_size_message: "اندازه پیام متنی",
      background_color: "رنگ پس زمینه",
      default: "پیشفرض",
      dark: "تاریک",
      date: "تاریخ",
      multimedia: "چند رسانه ای",
      date_item: {
        gregorian: "میلادی",
        hijri_shamsi: "هجری شمسی",
        hijri_lunar: "هجری قمری",
      },
      hour_24: "زمان 24 ساعته",
      show_chanel_vote_layout: "نمایش لایه ثبت رای در کانال",
      show_sender_name_in_groups: "نمایش نام فرستنده پیام در گروه",
      send_by_enter_key: "ارسال پیام با زدن کلید اینتر",
      play_message_sound_in_chat: "پخش صدای ارسال پیام در گفتگو",
      play_Message_Text_To_Voice: "قابلیت تبدیل نوشته به صدا",
      in_app_browser: "مرورگر درون برنامه ای",
      trim_video: "بریدن بخشی از ویدیو",
      compress_video: "فشرده سازی ویدیو",
      open_video_with_default_player: "باز شدن ویدیو با پخش کننده پیشفرض",
      crop_and_resize_photo: "بریدن و تغییر سایز تصویر",
      small_camera_in_attachments: "دوربین کوچک در پیوست ها",
      theme_layout: {
        title: "نوع پنجره",
        [MessengerThemeLayoutType.WIDE]: "تمام صفحه",
        [MessengerThemeLayoutType.BOXED]: "جعبه ای",
      },
    },
  },
  delete_room_for_owner: {
    [Room.Type.CHANNEL]: "حذف کانال",
    [Room.Type.GROUP]: "حذف روم",
    [Room.Type.CHAT]: "حذف گفتگو",
  },
  left_room_member: {
    [Room.Type.CHANNEL]: "ترک کردن کانال",
    [Room.Type.GROUP]: "ترک گروه",
    [Room.Type.CHAT]: "حذف گفتگو",
  },
  storage: {
    saved_file: "نگهداری فایل های چند رسانه ای",
    saved_file_title: "استفاده از حافظه و شبکه",
    auto_download_title: "دانلود خودکار محتوا",
    auto_download: "بارگیری خودکار محتوا",
    auto_play_media_title: "پخش خودکار محتوا",
    auto_play_gif: "اجرای خودکار تصاویر متحرک",
    auto_play_video: "پخش خودکار ویدیو",
    local_storage: "حافظه محلی",
    clear_local_storage: "پاکسازی حافظه محلی",
    saved_file_items: {
      forever: "برای همیشه",
      one_week: "یک هفته",
      six_month: "شش ماه",
    },
  },
  attachment_menu: {
    contact: "مخاطب",
    file: "فایل",
    photo: "تصویر",
    camera: "دوربین",
    location: "مکان",
  },
  callManager: {
    [SignalingOffer.Type.VOICE_CALLING]: "تماس صوتی آیگپ",
    [SignalingOffer.Type.VIDEO_CALLING]: "تماس تصویری آیگپ",
    signaling_status: {
      [SIGNALING_STATUS.CONNECTED]: "متصل شد...",
      [SIGNALING_STATUS.CONNECTING]: "در حال اتصال...",
      [SIGNALING_STATUS.DISCONNECTED]: "قطع شد...",
      [SIGNALING_STATUS.RINGING]: "در حال زنگ خوردن...",
      [SIGNALING_STATUS.CALLING]: "در حال تماس...",
      [SIGNALING_STATUS.REJECTED]: "رد شد...",
      [SIGNALING_STATUS.NOT_ANSWERED]: "جواب نداد...",
      [SIGNALING_STATUS.BUSY]: "مشغول...",
      [SIGNALING_STATUS.UNAVAILABLE]: "در دسترس نیست...",
    },
  },
  contact_message: {
    add_to_contact: "اضافه کردن به مخاطبین",
    view_contact: "مشاهده مخاطب",
  },
  copiedInClipboard: "کپی شد!",
  countries: {
    ad: "Andorra",
    ae: "United Arab Emirates",
    af: "Afghanistan",
    ag: "Antigua & Barbuda",
    ai: "Anguilla",
    al: "Albania",
    am: "Armenia",
    ao: "Angola",
    ar: "Argentina",
    as: "American Samoa",
    at: "Austria",
    au: "Australia",
    aw: "Aruba",
    az: "Azerbaijan",
    ba: "Bosnia & Herzegovina",
    bb: "Barbados",
    bd: "Bangladesh",
    be: "Belgium",
    bf: "Burkina Faso",
    bg: "Bulgaria",
    bh: "Bahrain",
    bi: "Burundi",
    bj: "Benin",
    bm: "Bermuda",
    bn: "Brunei Darussalam",
    bo: "Bolivia",
    bq: "Bonaire, Sint Eustatius & Saba",
    br: "Brazil",
    bs: "Bahamas",
    bt: "Bhutan",
    bw: "Botswana",
    by: "Belarus",
    bz: "Belize",
    ca: "Canada",
    cd: "Congo (Dem. Rep.)",
    cf: "Central African Rep.",
    cg: "Congo (Rep.)",
    ch: "Switzerland",
    ci: "Cote d`Ivoire",
    ck: "Cook Islands",
    cl: "Chile",
    cm: "Cameroon",
    cn: "China",
    co: "Colombia",
    cr: "Costa Rica",
    cu: "Cuba",
    cv: "Cape Verde",
    cw: "Curacao",
    cy: "Cyprus",
    cz: "Czech Republic",
    de: "Germany",
    dj: "Djibouti",
    dk: "Denmark",
    dm: "Dominica",
    do: "Dominican Rep.",
    dz: "Algeria",
    ec: "Ecuador",
    ee: "Estonia",
    eg: "Egypt",
    er: "Eritrea",
    es: "Spain",
    et: "Ethiopia",
    fi: "Finland",
    fj: "Fiji",
    fk: "Falkland Islands",
    fm: "Micronesia",
    fo: "Faroe Islands",
    fr: "France",
    ga: "Gabon",
    gb: "United Kingdom",
    gd: "Grenada",
    ge: "Georgia",
    gf: "French Guiana",
    gh: "Ghana",
    gi: "Gibraltar",
    gl: "Greenland",
    gm: "Gambia",
    gn: "Guinea",
    gp: "Guadeloupe",
    gq: "Equatorial Guinea",
    gr: "Greece",
    gt: "Guatemala",
    gu: "Guam",
    gw: "Guinea-Bissau",
    gy: "Guyana",
    hk: "Hong Kong",
    hn: "Honduras",
    hr: "Croatia",
    ht: "Haiti",
    hu: "Hungary",
    id: "Indonesia",
    ie: "Ireland",
    in: "India",
    io: "Diego Garcia",
    iq: "Iraq",
    ir: "Iran",
    is: "Iceland",
    it: "Italy",
    jm: "Jamaica",
    jo: "Jordan",
    jp: "Japan",
    ke: "Kenya",
    kg: "Kyrgyzstan",
    kh: "Cambodia",
    ki: "Kiribati",
    km: "Comoros",
    kn: "Saint Kitts & Nevis",
    kp: "North Korea",
    kr: "South Korea",
    kw: "Kuwait",
    ky: "Cayman Islands",
    kz: "Kazakhstan",
    la: "Laos",
    lb: "Lebanon",
    lc: "Saint Lucia",
    li: "Liechtenstein",
    lk: "Sri Lanka",
    lr: "Liberia",
    ls: "Lesotho",
    lt: "Lithuania",
    lu: "Luxembourg",
    lv: "Latvia",
    ly: "Libya",
    ma: "Morocco",
    mc: "Monaco",
    md: "Moldova",
    me: "Montenegro",
    mg: "Madagascar",
    mh: "Marshall Islands",
    mk: "Macedonia",
    ml: "Mali",
    mm: "Myanmar",
    mn: "Mongolia",
    mo: "Macau",
    mp: "Northern Mariana Islands",
    mq: "Martinique",
    mr: "Mauritania",
    ms: "Montserrat",
    mt: "Malta",
    mu: "Mauritius",
    mv: "Maldives",
    mw: "Malawi",
    mx: "Mexico",
    my: "Malaysia",
    mz: "Mozambique",
    na: "Namibia",
    nc: "New Caledonia",
    ne: "Niger",
    nf: "Norfolk Island",
    ng: "Nigeria",
    ni: "Nicaragua",
    nl: "Netherlands",
    no: "Norway",
    np: "Nepal",
    nr: "Nauru",
    nu: "Niue",
    nz: "New Zealand",
    om: "Oman",
    pa: "Panama",
    pe: "Peru",
    pf: "French Polynesia",
    pg: "Papua New Guinea",
    ph: "Philippines",
    pk: "Pakistan",
    pl: "Poland",
    pm: "Saint Pierre & Miquelon",
    pr: "Puerto Rico",
    ps: "Palestine",
    pt: "Portugal",
    pw: "Palau",
    py: "Paraguay",
    qa: "Qatar",
    re: "Reunion",
    ro: "Romania",
    rs: "Serbia",
    ru: "Russian Federation",
    rw: "Rwanda",
    sa: "Saudi Arabia",
    sb: "Solomon Islands",
    sc: "Seychelles",
    sd: "Sudan",
    se: "Sweden",
    sg: "Singapore",
    sh: "Saint Helena",
    si: "Slovenia",
    sk: "Slovakia",
    sl: "Sierra Leone",
    sm: "San Marino",
    sn: "Senegal",
    so: "Somalia",
    sr: "Suriname",
    ss: "South Sudan",
    st: "Sao Tome & Principe",
    sv: "El Salvador",
    sx: "Sint Maarten",
    sy: "Syria",
    sz: "Swaziland",
    tc: "Turks & Caicos Islands",
    td: "Chad",
    tg: "Togo",
    th: "Thailand",
    tj: "Tajikistan",
    tk: "Tokelau",
    tl: "Timor-Leste",
    tm: "Turkmenistan",
    tn: "Tunisia",
    to: "Tonga",
    tr: "Turkey",
    tt: "Trinidad & Tobago",
    tv: "Tuvalu",
    tw: "Taiwan",
    tz: "Tanzania",
    ua: "Ukraine",
    ug: "Uganda",
    us: "USA",
    uy: "Uruguay",
    uz: "Uzbekistan",
    vc: "Saint Vincent & the Grenadines",
    ve: "Venezuela",
    vg: "British Virgin Islands",
    vi: "US Virgin Islands",
    vn: "Vietnam",
    vu: "Vanuatu",
    wf: "Wallis & Futuna",
    ws: "Samoa",
    ye: "Yemen",
    yl: "Y-land",
    za: "South Africa",
    zm: "Zambia",
    zw: "Zimbabwe",
  },
  create_conversation_popup: {
    channel_type: {
      link_info: "اگر یک پیوند دائمی را تنظیم کنید، افراد دیگر قادر به یافتن و پیوستن به کانال شما خواهند بود. شما می توانید از 9-0، a-z و زیرخط استفاده کنید. حداقل طول 5 حرف است.",
      permanent_link: "لینک دائمی",
      private_channel: "کانال خصوصی",
      private_channel_info: "کاربران تنها می توانند به این کانال بپیوندند که توسط مدیر(ان) به عنوان اعضای کانال اضافه شوند.",
      public_channel: "کانال عمومی",
      public_channel_info: "کاربران می توانند با جستجوی نام کاربری یا دریافت لینک دعوت به این کانال بپیوندند.",
      your_link: "پیوند شما",
    },
    create_conversation: "ایجاد گفتگو",
    new_channel: "کانال جدید",
    new_contact: "مخاطب جدید",
    new_group: "گروه جدید",
  },
  date: {
    ago: "پیش",
    day: "روز",
    hour: "ساعت",
    later: "بعد",
    long_time_ago: "خیلی وقت پیش",
    minute: "دقیقه",
    month: "ماه",
    recently: "اخیرا",
    second: "ثانیه",
    week: "هفته",
    year: "سال",
    few_moment_ago: "چند لحظه پیش",
  },
  restrictions_media: "محدودیت در ارسال پیام چندرسانه ای!",
  restrictions_message: "محدودیت در ارسال پیام",
  registered_user_status: {
    support: "پشتیبانی",
    service_notification: "سرویس اعلانات برنامه",
  },
  emoji_tabs: {
    emoji: "ایموجی",
    gif: "استیکر متحرک",
    sticker: "استیکر",
  },
  errors: {
    "1": "The request is not valid",
    "2": "You have to log in first, then ask for performing this action",
    "3": "New client just connected to this session, you are not allowed to continue",
    "4": "This operation is not permitted",
    "5": "Getting response from the server has been timed out",
    "6": "For related requests; if one gets error, RELATION_ERROR will be sent to the others",
    "8": "Your session has been terminated by another device",
    "9": "Nickname is required to be set before continue to do the action",
    "10": "You have exceeded the number of requests allowed",
    "100": "Bad payload",
    "102": "Bad payload",
    "104": "There is no registered user with this given username",
    "105": "Your user account is blocked, you cannot verify the user",
    "106": "کد وارد شده اشتباه است",
    "107": "The Verification Code you entered has expired",
    "108": "The Verification Code is locked now due to many tries",
    "109": "Bad payload",
    "111": "Login failed",
    "112": "Bad payload",
    "114": "Bad payload",
    "116": "Bad payload",
    "118": "Bad payload",
    "120": "Bad payload",
    "122": "Bad payload",
    "124": "Bad payload",
    "126": "Bad payload",
    "128": "Bad payload",
    "130": "Bad payload",
    "135": "Your user account is blocked",
    "136": "The verification code was entered incorrectly too many times. Please try again later",
    "137": "You have requested the verification code exceedingly",
    "138": "Bad payload",
    "140": "You are forbidden to do the action",
    "141": "Bad payload",
    "143": "You are forbidden to do the action",
    "144": "Bad payload",
    "146": "You are forbidden to do the action",
    "147": "Bad payload",
    "149": "You are forbidden to do the action",
    "150": "Bad payload",
    "152": "Destruction Code for deleting user account has been entered incorrectly too many times",
    "153": "Destruction Code for deleting user account has been requested too many times",
    "154": "Bad payload",
    "156": "Account destruction token is incorrect",
    "157": "Account destruction token you entered has expired",
    "158": "Destruction Code for deleting user account has been entered incorrectly too many times",
    "159": "Bad payload",
    "161": "Bad payload",
    "164": "Bad payload",
    "166": "Bad payload",
    "168": "Bad payload",
    "170": "Bad payload",
    "172": "You are forbidden to do the action",
    "173": "Bad payload",
    "175": "The username has been recently updated; please keep waiting until you can renew it or choose the latest one again",
    "176": "Bad payload",
    "178": "There is no user with this UserID",
    "179": "Bad payload",
    "181": "This user has already been unblocked",
    "182": "Bad payload",
    "184": "Two-step Verification is activated",
    "185": "Bad payload",
    "187": "You are forbidden to do the action",
    "188": "You have not activated Two-step Verification yet",
    "189": "Bad payload",
    "191": "Password has been entered incorrectly too many times",
    "192": "You are forbidden to do the action",
    "193": "Password has not been set yet",
    "194": "Password is incorrect",
    "195": "Bad payload",
    "197": "Password has been entered incorrectly too many times",
    "198": "The old password in not correct",
    "199": "Bad payload",
    "200": "Bad payload",
    "202": "There is no active user with the given peer_ID",
    "203": "Bad payload",
    "205": "You are forbidden to do the action",
    "206": "Bad payload",
    "208": "You are forbidden to do the action",
    "209": "Bad payload",
    "211": "You are forbidden to do the action",
    "212": "Bad payload",
    "214": "You are forbidden to do the action",
    "215": "Bad payload",
    "217": "You are forbidden to do the action",
    "218": "Bad payload",
    "220": "You are forbidden to do the action",
    "221": "Bad payload",
    "223": "You are forbidden to do the action",
    "224": "Bad payload",
    "226": "You are forbidden to do the action",
    "227": "Bad payload",
    "229": "You are forbidden to do the action",
    "230": "Bad payload",
    "232": "You are forbidden to do the action",
    "233": "You have got blocked by the peer",
    "234": "You are not currently allowed to send message to the required recipient for the restriction made",
    "300": "Bad payload",
    "302": "Bad payload",
    "304": "This user has already joined this room",
    "305": "You are forbidden to do the action",
    "306": "Bad payload",
    "308": "You are forbidden to do the action",
    "309": "Bad payload",
    "311": "You are forbidden to do the action",
    "312": "Bad payload",
    "314": "You are forbidden to do the action",
    "315": "Bad payload",
    "317": "You are forbidden to do the action",
    "318": "Bad payload",
    "320": "You are forbidden to do the action",
    "321": "Bad payload in",
    "323": "You are forbidden to do the action",
    "324": "Bad payload",
    "326": "You are forbidden to do the action",
    "327": "Bad payload",
    "329": "You are forbidden to do the action",
    "330": "Bad payload",
    "332": "Bad payload",
    "334": "You are forbidden to do the action",
    "335": "Bad payload",
    "337": "You are forbidden to do the action",
    "338": "Bad payload",
    "340": "You are forbidden to do the action",
    "341": "Bad payload",
    "343": "You are forbidden to do the action",
    "344": "Bad payload",
    "346": "You are forbidden to do the action",
    "347": "Bad payload",
    "349": "You are forbidden to do the action",
    "350": "Bad payload",
    "352": "You are forbidden to do the action",
    "353": "Bad payload",
    "355": "You are forbidden to do the action",
    "356": "Bad payload",
    "358": "You are forbidden to do the action",
    "359": "Bad payload",
    "361": "You are forbidden to do the action",
    "362": "No more member can join this room",
    "363": "You are forbidden to do the action",
    "364": "Bad payload",
    "366": "Bad payload",
    "368": "Username has been changed recently, to renew it wait until the allowed time or choose the last one again",
    "369": "You are forbidden to do the action",
    "370": "Bad payload",
    "372": "You are forbidden to do the action",
    "373": "Bad payload",
    "375": "You are forbidden to do the action",
    "376": "Bad payload",
    "378": "You are forbidden to do the action",
    "379": "You cannot invite this user to groups because of the protected privacy",
    "380": "You are restricted to create more rooms",
    "381": "Bad payload",
    "383": "You are forbidden to do the action",
    "400": "Bad payload",
    "402": "Bad payload",
    "404": "This user has already joined this room",
    "405": "You are forbidden to do the action",
    "406": "Bad payload",
    "408": "You are forbidden to do the action",
    "409": "Bad payload",
    "411": "You are forbidden to do the action",
    "412": "Bad payload",
    "414": "You are forbidden to do the action",
    "415": "Bad payload",
    "417": "You are forbidden to do the action",
    "418": "Bad payload",
    "420": "You are forbidden to do the action",
    "421": "Bad payload in",
    "423": "You are forbidden to do the action",
    "424": "Bad payload",
    "426": "You are forbidden to do the action",
    "427": "Bad payload",
    "429": "You are forbidden to do the action",
    "430": "Bad payload",
    "432": "Bad payload",
    "434": "You are forbidden to do the action",
    "435": "Bad payload",
    "437": "You are forbidden to do the action",
    "438": "Bad payload",
    "440": "You are forbidden to do the action",
    "441": "Bad payload",
    "443": "You are forbidden to do the action",
    "444": "Bad payload",
    "446": "You are forbidden to do the action",
    "447": "Bad payload",
    "449": "You are forbidden to do the action",
    "450": "Bad payload",
    "452": "You are forbidden to do the action",
    "453": "Bad payload",
    "455": "Bad payload",
    "457": "Username has been changed recently, to renew it wait until the allowed time or choose the last one again",
    "458": "You are forbidden to do the action",
    "459": "You are forbidden to do the action",
    "460": "Bad payload",
    "462": "You are forbidden to do the action",
    "463": "Bad payload",
    "465": "You are forbidden to do the action",
    "466": "Bad payload",
    "468": "You are forbidden to do the action",
    "469": "Bad payload",
    "471": "You are forbidden to do the action",
    "472": "Bad payload",
    "474": "You are forbidden to do the action",
    "475": "Bad payload",
    "477": "You are forbidden to do the action",
    "478": "You cannot invite this user to groups because of the protected privacy",
    "479": "You are restricted to create more rooms",
    "480": "Bad payload",
    "482": "You are forbidden to do the action",
    "483": "Bad payload",
    "485": "You are forbidden to do the action",
    "500": "Location could not be found",
    "501": "Bad payload",
    "502": "Bad payload",
    "504": "Bad payload",
    "600": "Bad payload",
    "602": "Virtual Error",
    "603": "Virtual Error",
    "604": "Virtual Error",
    "605": "Virtual Error",
    "606": "Virtual Error",
    "607": "Virtual Error",
    "608": "Virtual Error",
    "609": "Virtual Error",
    "610": "Bad payload",
    "612": "Bad payload",
    "614": "No Such room ",
    "615": "Bad payload",
    "617": "There is no other massage to view",
    "618": "Bad payload",
    "620": "There is no other massage to view",
    "621": "Bad payload",
    "623": "There is no user ",
    "624": "Bad payload",
    "626": "The requested message could not be found",
    "627": "Bad payload",
    "629": "Invite Link of the room is invalid",
    "630": "Bad payload",
    "632": "You are forbidden to do the action",
    "633": "The user has already joined this room",
    "634": "No other user is accepted to join this room because of the allowed number reached",
    "635": "Bad payload",
    "637": "You are forbidden to do the action",
    "638": "The user has already joined this room",
    "639": "No other user is accepted to join this room because of the allowed number reached",
    "640": "Bad payload",
    "642": "You are forbidden to do the action",
    "643": "Bad payload",
    "645": "Bad payload",
    "647": "Bad payload",
    "649": "No such room was found",
    "650": "Bad payload",
    "652": "You are forbidden to do the action",
    "653": "Bad payload",
    "655": "You are forbidden to do the action",
    "656": "Bad payload",
    "658": "You have already reported this message/room",
    "659": "You are forbidden to do the action",
    "660": "Bad payload",
    "661": "You are forbidden to do the action",
    "663": "Bad payload",
    "664": "You are forbidden to do the action",
    "665": "You are forbidden to do the action",
    "666": "Bad payload",
    "667": "You are forbidden to do the action",
    "668": "Bad payload",
    "669": "You are forbidden to do the action",
    "670": "Bad payload",
    "671": "You are forbidden to do the action",
    "672": "Bad payload",
    "673": "You are forbidden to do the action",
    "674": "Bad payload",
    "675": "You are forbidden to do the action",
    "676": "Bad payload",
    "677": "You are forbidden to do the action",
    "700": "Bad payload",
    "702": "Bad payload",
    "704": "Bad payload",
    "706": "You are forbidden to do the action",
    "707": "Bad payload",
    "709": "No such file was found",
    "710": "Bad payload",
    "712": "No such file was found",
    "713": "Bad payload",
    "715": "No such file was found",
    "800": "Bad payload",
    "802": "Bad payload",
    "804": "Bad payload",
    "806": "Bad payload",
    "808": "Bad payload",
    "900": "Bad payload",
    "902": "Bad payload",
    "904": "You are forbidden to do the action",
    "905": "You have got blocked by the peer",
    "906": "You cannot call this user because of the protected privacy",
    "907": "Bad payload",
    "909": "You are forbidden to do the action",
    "910": "Bad payload",
    "912": "You are forbidden to do the action",
    "913": "Bad payload",
    "915": "You are forbidden to do the action",
    "916": "Bad payload",
    "918": "You are forbidden to do the action",
    "921": "You are forbidden to do the action",
    "922": "Bad payload",
    "926": "Bad payload",
    "928": "You are forbidden to do the action",
    "1000": "Bad payload",
    "1002": "Bad payload",
    "1004": "Bad payload",
    "1006": "You are forbidden to do the action",
    "1007": "Bad payload",
    "1009": "You are forbidden to do the action",
    "1010": "Bad payload",
    "1012": "You are forbidden to do the action",
    "1013": "Bad payload",
    "1015": "You are forbidden to do the action",
    "1016": "Bad payload",
    "1018": "You are forbidden to do the action",
    "9000": "Bad payload",
    "9002": "Server was not able to get a valid or any response from the Wallet server",
    "9003": "You are forbidden to do the action",
    "9004": "Bad payload",
    "9006": "Server was not able to get a valid or any response from the Wallet server",
    "9007": "You are forbidden to do the action",
    "9008": "Recipient are forbidden",
    "9009": "Error from Wallet server",
    "9010": "Recipient is not registered in wallet",
    "9011": "Bad payload",
    "9013": "You are forbidden to do the action",
    "9014": "Bad payload",
    "9016": "No such user was found",
    "9100": "Bad payload",
    "9102": "Server was not able to get a valid or any response from the Mpl server",
    "9103": "You are forbidden to do the action",
    "9104": "Bad payload",
    "9106": "Server was not able to get a valid or any response from the Mpl server",
    "9107": "You are forbidden to do the action",
    "9108": "Bad payload",
    "9110": "Server was not able to get a valid or any response from the Mpl server",
    "9111": "You are forbidden to do the action",
    "9112": "Bad payload",
    "9114": "Server was not able to get a valid or any response from the Mpl server",
    "9115": "You are forbidden to do the action",
    "9116": "Bad payload",
    "9118": "Server was not able to get a valid or any response from the Mpl server",
    "9119": "You are forbidden to do the action",
    "9120": "Bad payload",
    "9121": "You are forbidden to do the action",
    "9122": "Server was not able to get a valid or any response from the Mpl server",
    "9123": "Bad payload",
    "9125": "Bad payload",
    "9127": "Server was not able to get a valid or any response from the Mpl server",
    "9128": "You are forbidden to do the action",
    "9200": "Bad payload",
    "9202": "Server was not able to get a valid or any response from the bill inquiry server",
    "9203": "You are forbidden to do the action",
    "9204": "Bad payload",
    "9206": "Server was not able to get a valid or any response from the bill inquiry server",
    "9207": "You are forbidden to do the action",
    "10101": "Password has been entered incorrectly too many times",
    "10102": "Password is not valid",
    "10103": "Bad payload",
    "10105": "Password is not correct",
    "10106": "Password has been entered incorrectly too many times",
    "10107": "Password has not been set yet",
    "10108": "Bad payload",
    "10110": "The code to verify the recovery E-mail has been entered incorrectly too many times",
    "10111": "The code to verify and authenticate recovery E-mail has expired",
    "10112": "Password has not been set yet",
    "10113": "The verification code you entered for E-mail recovery is incorrect",
    "10114": "Bad payload",
    "10116": "The code to verify the recovery E-mail has been entered incorrectly too many times",
    "10117": "Password has not been set yet",
    "10118": "Password is incorrect",
    "10119": "Recovery E-mail has already been confirmed",
    "10120": "Bad payload",
    "10122": "Password has not been set yet",
    "10123": "No E-mail has been set to recover password",
    "10124": "Password recovery token has been entered incorrectly too many times",
    "10125": "Bad payload",
    "10127": "Password recovery token has been entered incorrectly too many times",
    "10128": "Password recovery token has expired",
    "10129": "Password recovery token is invalid",
    "10130": "Password has not been set yet",
    "10131": "Bad payload",
    "10133": "Password has been entered incorrectly too many times",
    "10134": "At least one of the answers is not valid",
    "10135": "Password has not been set yet",
    "10136": "Bad payload",
    "10138": "Password has been entered incorrectly too many times",
    "10139": "Password has not been set yet",
    "10140": "Password is incorrect",
    "10141": "Bad payload",
    "10143": "Password has been entered incorrectly too many times",
    "10144": "Password has not been set yet",
    "10145": "Password is incorrect",
    "10146": "Bad payload",
    "10148": "Bad payload",
    "10150": "Bad payload",
    "10152": "Token is invalid",
    "10153": "Token has expired",
    "10154": "You are forbidden to do the action",
    "10155": "You are forbidden to do the action",
    "10156": "You are forbidden to do the action",
    "10157": "Bad payload",
    "10159": "Password has not been set yet",
    "10160": "There is no confirmed E-mail to be sent the verification token",
    "10161": "Bad payload",
    "10163": "Bad payload",
    "10165": "Bad payload",
    "10167": "You have already reported this user",
    "10168": "You are forbidden to do the action",
    "10169": "You are forbidden to do the action",
    "10170": "You are forbidden to login again",
    "10171": "You are forbidden to do the action due to wallet restriction",
    "10172": "Server was not able to get a valid or any response from the Wallet server",
    "10173": "Bad payload",
    "10175": "Bad payload",
    "10177": "Bad payload",
    "10179": "Bad payload",
    "10182": "Bad payload",
    "100_1": "Country code is invalid",
    "100_2": "Username is invalid",
    "100_3": "PreferenceMethod is invalid",
    "102_1": "Verification code is invalid",
    "102_2": "Username is invalid",
    "109_1": "Token is invalid",
    "109_2": "App Name is invalid",
    "109_3": "App ID is invalid",
    "109_4": "App Build Version is invalid",
    "109_5": "App Version is invalid",
    "109_6": "Platform is invalid",
    "109_7": "Device is invalid",
    "109_8": "Device Name is invalid",
    "109_9": "Language is invalid",
    "111_4": "Your account is blocked",
    "116_1": "Gender is invalid",
    "118_1": "Phone Number is not valid",
    "118_2": "First Name is not valid",
    "118_3": "Last Name is not valid",
    "118_4": "Force is not valid",
    "118_5": "Too many contacts",
    "122_1": "Phone Number is not valid",
    "122_invalid": "Phone Number is not valid",
    "124_1": "Phone Number is invalid",
    "124_2": "First Name is invalid",
    "124_3": "Last Name is invalid",
    "124_4": "It's required to enter first name or last name",
    "138_1": "Attachment is not valid",
    "141_1": "Avatar_ID is invalid",
    "144_1": "User_ID is invalid",
    "147_1": "User_ID is incorrect",
    "154_1": "Account destruction token is incorrect",
    "154_2": "Account destruction reason is not valid",
    "161_1": "Self_Remove is invalid",
    "164_2": "Username is invalid",
    "164_3": "نام کاربری مورد نظر شما قبلا ثبت شده است",
    "166_1": "Status is incorrect",
    "170_1": "Session_ID is invalid",
    "173_1": "Session_ID is invalid",
    "176_1": "User_ID is incorrect",
    "179_1": "User_ID is incorrect",
    "189_1": "Password is wrong",
    "195_1": "Old Password is wrong",
    "195_2": "New Password is invalid",
    "195_3": "Recovery E-mail is not valid",
    "195_4": "Recovery E-mail is not valid",
    "195_5": "The first recovery question is invalid",
    "195_6": "Answer of the first recovery question is invalid",
    "195_7": "The second recovery question is invalid",
    "195_8": "Answer of the second recovery question is invalid",
    "195_9": "Password hint is not valid",
    "199_1": "Password is invalid",
    "200_1": "Peer_ID is invalid",
    "202_3": "Peer's account has got blocked",
    "203_1": "Room_ID is invalid",
    "203_2": "Message is invalid",
    "203_3": "Attachment is invalid",
    "203_4": "Attachment is invalid",
    "203_5": "Attachment is invalid",
    "203_6": "Attachment is invalid",
    "203_7": "Attachment is invalid",
    "203_8": "Attachment is invalid",
    "203_9": "Message is invalid",
    "203_10": "Attachment is invalid",
    "203_11": "Message is invalid",
    "203_12": "Attachment is invalid",
    "203_13": "Message is invalid",
    "203_14": "Attachment is invalid",
    "203_15": "Message is invalid",
    "203_16": "Attachment is invalid",
    "203_17": "Location is invalid",
    "203_18": "Location.lat is invalid",
    "203_19": "Location.lon is invalid",
    "203_22": "Contact is invalid",
    "203_23": "Message_Type is invalid",
    "203_24": "No such file is found",
    "203_25": "ReplyTo is invalid",
    "203_26": "ForwardFrom.Room_ID is invalid",
    "203_27": "ForwardFrom.Message_ID is invalid",
    "203_28": "ForwardFrom is invalid",
    "203_29": "ReplyTo and ForwardFrom have been set",
    "203_30": "Message is invalid",
    "203_31": "Attachment is invalid",
    "203_32": "Message is too long",
    "203_33": "Random id is invalid",
    "203_34": "additional_type is invalid",
    "203_35": "additional_data invalid",
    "203_36": "Sticker Message invalid",
    "203_37": "Sticker Data invalid",
    "206_1": "Room_ID is invalid",
    "206_2": "Message_ID is invalid",
    "209_1": "Room_ID is invalid",
    "209_2": "Message_ID is invalid",
    "209_3": "Message is invalid",
    "212_1": "Room_ID is invalid",
    "212_2": "Message_ID is invalid",
    "212_3": "Both are invalid",
    "215_1": "Room_ID is invalid",
    "215_2": "Clear_ID is invalid",
    "218_1": "Room_ID is invalid",
    "221_1": "Room_ID is invalid",
    "221_2": "Message_ID is invalid",
    "221_3": "ReplyTo is invalid",
    "224_1": "Room_ID is invalid",
    "227_1": "Room_ID is invalid",
    "227_2": "Group Name is not valid",
    "227_3": "Group Description is not valid",
    "230_1": "Room_ID is invalid",
    "230_2": "Action is wrong",
    "230_3": "Action_ID is not valid",
    "300_1": "Room_Name for Group is invalid",
    "300_2": "Group Description is invalid",
    "302_1": "Room_ID is invalid",
    "302_2": "User_ID is invalid",
    "302_3": "StartMessage_ID is invalid",
    "306_1": "Room_ID is invalid",
    "306_2": "Message is invalid",
    "306_3": "Attachment is invalid",
    "306_4": "Attachment is invalid",
    "306_5": "Attachment is invalid",
    "306_6": "Attachment is invalid",
    "306_7": "Attachment is invalid",
    "306_8": "Attachment is invalid",
    "306_9": "Message is invalid",
    "306_10": "Attachment is invalid",
    "306_11": "Message is invalid",
    "306_12": "Attachment is invalid",
    "306_13": "Message is invalid",
    "306_14": "Attachment is invalid",
    "306_15": "Message is invalid",
    "306_16": "Attachment is invalid",
    "306_17": "Location is invalid",
    "306_18": "Location.lat is invalid",
    "306_19": "Location.lon is invalid",
    "306_22": "Contact is invalid",
    "306_23": "Message_Type is invalid",
    "306_24": "No such file is found",
    "306_25": "ReplyTo is invalid",
    "306_26": "ForwardFrom.Room_ID is invalid",
    "306_27": "ForwardFrom.Message_ID is invalid",
    "306_28": "ForwardFrom is invalid",
    "306_29": "ReplyTo and ForwardFrom have been set",
    "306_30": "Message is invalid",
    "306_31": "Attachment is invalid",
    "306_32": "Message is too long",
    "306_33": "Random id is invalid",
    "306_34": "additional_type is invalid",
    "306_35": "additional_data invalid",
    "306_36": "Sticker Message invalid",
    "306_37": "Sticker Data invalid",
    "309_1": "Room_ID is invalid",
    "309_2": "Message_ID is invalid",
    "309_3": "Status is invalid",
    "312_1": "Room_ID is invalid",
    "312_2": "Message_ID is invalid",
    "315_1": "Room_ID is invalid",
    "315_2": "Clear_ID is invalid",
    "318_1": "Room_ID is invalid",
    "318_2": "Member_ID is invalid",
    "321_1": "Room_ID is invalid",
    "321_2": "Member_ID is invalid",
    "324_1": "Room_ID is invalid",
    "324_2": "Member_ID is invalid",
    "327_1": "Room_ID is invalid",
    "327_2": "Member_ID is invalid",
    "330_1": "Room_ID is invalid",
    "330_2": "Group Name is invalid",
    "330_3": "Group Description is invalid",
    "332_1": "Room_ID is invalid",
    "332_2": "Member_ID is invalid",
    "335_1": "Room_ID is invalid",
    "338_1": "Attachment is invalid",
    "338_2": "Room_ID is invalid",
    "341_1": "Avatar_ID is invalid",
    "341_2": "Room_ID is invalid",
    "347_1": "Room_ID is invalid",
    "347_2": "Message_ID is invalid",
    "347_3": "ReplyTo is invalid",
    "350_1": "Room_ID is invalid",
    "353_1": "Room_ID is invalid",
    "353_2": "FilterRole is invalid",
    "353_3": "OffSet is invalid",
    "353_4": "Limit is",
    "356_1": "Room_ID is invalid",
    "359_1": "Room_ID is invalid",
    "359_2": "Action is wrong",
    "359_3": "Action_ID is not valid",
    "364_1": "Room_ID is invalid",
    "366_1": "Room_ID is invalid",
    "366_2": "Username is invalid",
    "366_3": "This username has already been taken by another user",
    "366_4": "More than the allowed usernames have been selected by you",
    "370_1": "Room_ID is invalid",
    "373_1": "Room_ID is invalid",
    "376_1": "Room_ID is invalid",
    "376_2": "Message_ID is invalid",
    "376_3": "Message is invalid",
    "381_1": "Room_ID is invalid",
    "381_2": "Message_ID is invalid",
    "400_1": "Room_Name for Channel is invalid",
    "400_2": "Channel Description is invalid",
    "402_1": "Room_ID is invalid",
    "402_2": "User_ID_Member is invalid",
    "406_1": "Room_ID is invalid",
    "406_2": "Message is invalid",
    "406_3": "Attachment is invalid",
    "406_4": "Attachment is invalid",
    "406_5": "Attachment is invalid",
    "406_6": "Attachment is invalid",
    "406_7": "Attachment is invalid",
    "406_8": "Attachment is invalid",
    "406_9": "Message is invalid",
    "406_10": "Attachment is invalid",
    "406_11": "Message is invalid",
    "406_12": "Attachment is invalid",
    "406_13": "Message is invalid",
    "406_14": "Attachment is invalid",
    "406_15": "Message is invalid",
    "406_16": "Attachment is invalid",
    "406_17": "Location is invalid",
    "406_18": "Location.lat is invalid",
    "406_19": "Location.lon is invalid",
    "406_22": "Contact is invalid",
    "406_23": "Message_Type is invalid",
    "406_24": "No such file is found",
    "406_25": "ReplyTo is invalid",
    "406_26": "ForwardFrom.Room_ID is invalid",
    "406_27": "ForwardFrom.Message_ID is invalid",
    "406_28": "ForwardFrom is invalid",
    "406_29": "ReplyTo and ForwardFrom have been set",
    "406_30": "Message is invalid",
    "406_31": "Attachment is invalid",
    "406_32": "Message is too long",
    "406_33": "Random id is invalid",
    "406_34": "additional_type is invalid",
    "406_35": "additional_data invalid",
    "406_36": "Sticker Message invalid",
    "406_37": "Sticker Data invalid",
    "409_1": "Room_ID is invalid",
    "412_1": "Room_ID is invalid",
    "412_2": "Message_ID is invalid",
    "415_1": "Room_ID is invalid",
    "415_2": "FilterRole is invalid",
    "415_3": "OffSet is invalid",
    "415_4": "Limit is",
    "418_1": "Room_ID is invalid",
    "418_2": "Member_ID is invalid",
    "421_1": "Room_ID is invalid",
    "421_2": "Member_ID is invalid",
    "424_1": "Room_ID is invalid",
    "424_2": "Member_ID is invalid",
    "427_1": "Room_ID is invalid",
    "427_2": "Member_ID is invalid",
    "430_1": "Room_ID is invalid",
    "430_2": "Channel Name is invalid",
    "430_3": "Channel Description is invalid",
    "432_1": "Room_ID is invalid",
    "432_2": "Member_ID is invalid",
    "435_1": "Room_ID is invalid",
    "438_1": "Attachment is invalid",
    "438_2": "Room_ID is invalid",
    "441_1": "Avatar_ID is invalid",
    "441_2": "Room_ID is invalid",
    "447_1": "Room_ID is invalid",
    "447_2": "Message_ID is invalid",
    "447_3": "ReplyTo is invalid",
    "450_1": "Room_ID is invalid",
    "453_1": "Room_ID is invalid",
    "455_1": "Room_ID is invalid",
    "455_2": "Username is invalid",
    "455_3": "This username has already been taken by another user",
    "455_4": "More than the allowed usernames have been selected by you",
    "460_1": "Room_ID is invalid",
    "463_1": "Room_ID is invalid",
    "466_1": "Room_ID is invalid",
    "466_2": "Signature is invalid",
    "469_1": "Room_ID is invalid",
    "469_2": "At least one message is required",
    "469_3": "Number of messages is more than the allowed",
    "469_4": "Message_ID is invalid",
    "472_1": "Room_ID is invalid",
    "472_2": "Message_ID is invalid",
    "472_3": "Reaction is invalid",
    "475_1": "Room_ID is invalid",
    "475_2": "Message_ID is invalid",
    "475_3": "Message is invalid",
    "480_1": "Room_ID is invalid",
    "480_2": "reaction_status is invalid",
    "483_1": "Room_ID is invalid",
    "483_2": "Message_ID is invalid",
    "501_1": "IsoCode is invalid",
    "502_1": "ID is Wrong",
    "504_1": "Fit is invalid",
    "600_1": "Room_ID is invalid",
    "600_2": "MessageVersion is invalid",
    "600_3": "StatusVersion is invalid",
    "600_4": "DeleteVersion is invalid",
    "600_5": "OfflineDeleted is invalid",
    "600_6": "OfflineEdited.Message_ID is invalid",
    "600_7": "OfflineEdited.Message is invalid",
    "600_8": "OfflineSeen is invalid",
    "600_9": "Clear_ID is invalid",
    "600_10": "CacheStart_ID is invalid",
    "600_11": "CacheEnd_ID is invalid",
    "600_12": "OfflineMute is invalid",
    "600_13": "Your request is totally wrong",
    "600_14": "OfflineListened is invalid",
    "600_15": "Your request is totally wrong",
    "600_16": "OfflineDeletedDeprecated & OfflineDeleted have been set both",
    "600_17": "OfflineDeleted.Message_ID is invalid",
    "600_18": "OfflineDeleted.both is invalid",
    "610_1": "OffSet is invalid",
    "610_2": "Limit is invalid",
    "612_1": "Room_ID is invalid",
    "615_1": "Room_ID is invalid",
    "615_2": "FirstMessage_ID is invalid",
    "615_3": "Direction is wrong",
    "615_4": "Limit is invalid",
    "618_1": "Room_ID is invalid",
    "618_2": "OffSet is invalid",
    "618_3": "Filter is invalid",
    "618_4": "OffSet.Message_ID is invalid",
    "621_1": "Username is incorrect",
    "624_1": "Room_ID is invalid",
    "624_2": "Message_ID is invalid",
    "627_1": "Invite Token is not valid",
    "630_1": "Invite Token is not valid",
    "635_1": "Username is invalid",
    "640_1": "Room_ID is invalid",
    "643_1": "Room_ID is invalid",
    "645_1": "Query is invalid",
    "647_1": "Room_ID is invalid",
    "650_1": "Room_ID is invalid",
    "650_2": "RoomMute is invalid",
    "653_1": "Room_ID is invalid",
    "653_2": "PIN is invalid",
    "656_1": "Room_ID is invalid",
    "656_2": "Message_ID is invalid",
    "656_3": "Reason is invalid",
    "656_4": "Description is",
    "660_1": "token is invalid",
    "660_2": "type is invalid",
    "674_1": "Poll ID",
    "674_2": "Project ID",
    "676_1": "ITEM ID",
    "677_1": "Error in get poll",
    "677_2": "Poll not found",
    "677_3": "Poll not found",
    "677_4": "Error in get poll count",
    "677_5": "Poll count not found",
    "677_6": "Maximum vote limit",
    "677_7": "Cache Error",
    "677_8": "Duplicate entry",
    "700_1": "Size is invalid",
    "702_1": "Size is invalid",
    "702_2": "First bytes are invalid",
    "702_3": "Last bytes are invalid",
    "702_4": "FileHash is invalid",
    "702_5": "FileName is invalid",
    "704_1": "Token is invalid",
    "704_2": "OffSet is invalid",
    "704_3": "OffSet is invalid",
    "704_4": "Bytes are invalid",
    "707_1": "Token is invalid",
    "710_1": "Token is invalid",
    "713_1": "Token is invalid",
    "713_2": "OffSet is invalid",
    "713_3": "MaxLimit is invalid",
    "713_4": "Selector is invalid",
    "800_1": "InviteToken is invalid",
    "802_1": "Username is invalid",
    "802_2": "Message_ID is invalid",
    "804_1": "AppName is invalid",
    "804_2": "App_ID is invalid",
    "804_3": "AppBuildVersion is invalid",
    "804_4": "AppVersion is invalid",
    "804_5": "Platform is invalid",
    "804_6": "PlatformVersion is invalid",
    "804_7": "Device is invalid",
    "804_8": "DeviceName is invalid",
    "806_1": "Phone is invalid",
    "806_2": "First name is invalid",
    "806_3": "Last name is invalid",
    "902_1": "CalledUser_ID is invalid",
    "902_2": "Type is invalid",
    "902_3": "Caller_SDP is invalid",
    "910_1": "Called_SDP is invalid",
    "913_1": "Candidate is invalid",
    "913_2": "SDP_MID is invalid",
    "913_3": "SDP_M_Line_Index is invalid",
    "919_1": "Hold is invalid",
    "922_1": "Pagination is invalid",
    "922_2": "OffSet is invalid",
    "922_3": "Limit is invalid",
    "924_1": "Clear_ID is invalid",
    "926_1": "ID is invalid",
    "926_2": "Rate is invalid",
    "926_3": "Reason is invalid",
    "1002_1": "Enable is invalid",
    "1004_1": "Lat is invalid",
    "1004_2": "Lon is invalid",
    "1007_1": "User_ID is invalid",
    "1010_1": "Comment is invalid",
    "1013_1": "Lat is invalid",
    "1013_2": "Lon is invalid",
    "1016_1": "Lat is invalid",
    "1016_2": "Lon is invalid",
    "9004_1": "language is invalid",
    "9004_2": "jwt is invalid",
    "9004_3": "to_user_id is invalid",
    "9004_4": "amount is invalid",
    "9004_5": "description is invalid",
    "9014_1": "wallet_id is invalid",
    "9100_1": "bill_id is invalid",
    "9100_2": "pay_id is invalid",
    "9104_1": "charge_mobile_number is invalid",
    "9104_3": "amount is invalid",
    "9108_1": "amount is invalid",
    "9108_2": "to_id is invalid",
    "9108_3": "invoice number is invalid",
    "9108_4": "description is invalid",
    "9108_5": "Inquiry is invalid",
    "9112_1": "data in invalid",
    "9112_2": "PayData is not exist",
    "9112_3": "PayData is invalid",
    "9120_1": "invoice number is invalid",
    "9120_2": "Confirm or reverse is invalid",
    "9123_1": "Status is invalid",
    "9123_2": "Pagination is invalid",
    "9125_1": "Data is invalid",
    "9125_2": "To user id is invalid",
    "9200_1": "mobile_number is invalid",
    "9204_1": "province_code is invalid",
    "9204_2": "telephone_number is invalid",
    "10103_1": "Password is not correct",
    "10108_1": "Token is incorrect",
    "10114_1": "Password is incorrect",
    "10114_2": "Recovery E-mail is incorrect",
    "10114_3": "Recovery E-mail is incorrect",
    "10125_1": "Token is incorrect",
    "10131_1": "The first answer is incorrect",
    "10131_2": "The second answer is incorrect",
    "10136_1": "Password is incorrect",
    "10136_2": "The first question is invalid",
    "10136_3": "Answer of the first question is incorrect",
    "10136_4": "The second question is invalid",
    "10136_5": "Answer of the second question is incorrect",
    "10141_1": "Password is incorrect",
    "10141_2": "Password hint is invalid",
    "10146_1": "Type is wrong",
    "10148_1": "Type is wrong",
    "10148_2": "Level is wrong",
    "10150_1": "Token is invalid",
    "10161_1": "Bio is invalid",
    "10165_1": "User_ID is invalid",
    "10165_2": "Reason is invalid",
    "10165_3": "Description is invalid",
    "10173_1": "status is invalid",
    "10177_1": "phone format is invalid",
    "10178_1": "Failed to read user representative",
    "10178_2": "Already Registered",
    "10178_3": "Error in update user",
    "10179_1": "Invalid offset",
    "10179_2": "Invalid limit",
    "10180_1": "Failed to read user activities",
    "10181_1": "Failed to read user score",
    "10182_1": "Invalid plan code",
    "10183_1": "Failed to read plan",
    "10183_2": "Plan not found",
    "10183_3": "Failed to read user's activity",
    "10183_4": "Failed to update user's score",
    "10183_5": "Failed to set activity",
    "10183_6": "Failed to rollback score",
  },
  global: {
    insert_location: "در قسمت تنظیمات سیستم خود موقعیت مکانی را فعال کنید .",
    not_found_location: "موقعیت شما شناسایی نشد",
    map: "نقشه",
    send_location: "ارسال موقعیت",
    connection_faild: "در انتظار اتصال به اینترنت",
    video_call: "تماس تصویری",
    voice_call: "تماس صوتی",
    go_to_roadmap: "دیدن نقشه توسعه",
    coming_soon: "به زودی",
    beta: "نسخه آزمایشی",
    drag_file_here: "محل جاگذاری فایل",
    send_original: "ارسال فایل اصلی",
    crop_and_send: "برش و ارسال",
    active: "فعال",
    add: "افزودن",
    agree: "پذیرش",
    all: "همه",
    are_you_sure: "آیا مطمئن هستید؟",
    are_you_sure_delete_account: "آیا از حذف این حساب کاربری اطمینان دارید؟",
    are_you_sure_delete_account_description: "در صورتی که اکانت خود را حذف کنید، همه فایل هایی که به صورت پیام دریافت کرده اید نیز به طور دائم حذف خواهند شد!",
    block: "مسدود",
    bot: "ربات",
    call: "تماس ها",
    cancel: "لغو",
    channel_info: "اطلاعات کانال",
    close: "بستن",
    cloud: "فضای ابری",
    confirm: "تایید",
    contact: "مخاطبین",
    copy: "کپی",
    copy_link: "کپی لینک",
    copyright: "تاریخ انتشار: {{year}} © تمامی حقوق محفوظ است",
    country: "کشور",
    credit: "اعتبار",
    dark_mode: "حالت تاریک",
    date: "تاریخ",
    delete: "حذف",
    delete_for_all: "حذف برای همه",
    delete_image: "حدف تصویر",
    description: "توضیحات",
    disagree: "عدم پذیرش",
    discovery: "آیلند",
    download: "دانلود",
    edit: "ویرایش",
    first_name: "نام",
    forward: "ارسال",
    forward_to: "ارسال به ({{forwardCount}})",
    forwarded: "پیام از",
    group_info: "اطلاعات گروه",
    inactive: "غیرفعال",
    invite: "دعوت",
    invite_friends: "دعوت کردن دوستان",
    last_name: "نام خانوادگی",
    members: "اعضا",
    mobile: "موبایل",
    month: "ماه",
    nearby: "اطراف من",
    no: "خیر",
    online: "آنلاین",
    password: "رمز عبور",
    pin: "پین",
    please_wait: "لطفا صبر کنید",
    profile: "پروفایل",
    qrcode_scan: "اسکن بارکد",
    rank: "رتبه",
    reason: "دلیل",
    recovery_email: "ایمیل بازیابی",
    remove: "حذف کردن",
    replied: "پاسخ به",
    reply: "پاسخ",
    report: "گزارش",
    return_to_igap: "بازگشت به آیگپ",
    riyal: "ریال",
    score: "امتیاز",
    from: "از",
    ivand_rank: "از {{number}}",
    ivand_title: "شرح امتیازات",
    ivand_history: "تاریخچه امتیازات",
    point: "امتیاز",
    your_point: "امتیاز شما",
    upgrade_point: "همین حالا امتیازت رو افزایش بده!",
    search: "جست و جو",
    search_member: "جست و جو اعضا",
    select: "انتخاب",
    search_not_found: "نتیجه ای یافت نشد",
    selected_item: "{{number}} مورد انتخاب شده است.",
    send: "ارسال",
    settings: "تنظیمات",
    submit: "ثبت",
    time: "ساعت",
    title: "آیگپ",
    toman: "تومان",
    unblock: "رفع مسدودیت",
    unpin: "حذف پین",
    update_check: "کنترل بروزرسانی",
    user_info: "اطلاعات کاربر",
    version: "نسخه برنامه",
    welcome: "به نسخه رسمی {{platform}} آیگپ خوش آمدید",
    yes: "بله",
    wait: "لطفا صبر کنید",
    next: "ادامه",
    room_info: "اطلاعات اتاق",
    popup_buy_sticker: "خرید استیکر هدیه",
    popup_gift_card_detail: "جزئیات گیفت کارت",
    popup_digital_gift_card_information: "اطلاهات کارت هدیه دیجیتال",
    popup_digital_gift_card_information_save_to_clipboard: "برای کپی کلیک کنید",
    popup_digital_gift_card_credit_card_number: "شماره کارت",
    popup_digital_gift_card_expiration_date: "تاریخ انقضا",
    popup_digital_gift_card_cvv2: "CVV2",
    popup_digital_gift_card_second_internet_password: "رمز دوم",
    nationalCode: "کد ملی",
    enable: "فعالسازی",
    favourite_channels: "کانال های جذاب",
    popup_inquiry_mci: "استعلام قبوض همراه اول",
    popup_inquiry_telecom: "استعلام قبوض تلفن ثابت",
    phone_number: "شماره تلفن",
    prefix: "پیش شماره",
    pause: "توقف",
    continue: "ادامه",
    go_to_message: "برو به پیام",
    discovery_news: "اخبار روز",
    room_not_found: "اتاقی با لینک مورد نظر یافت نشد",
    something_wrong: "مشکلی پیش آمده لطفا مجددا تلاش نمایید",
    success_message: "عملیات با موفقیت انجام شد",
    unread_messages: "پیام های خوانده نشده",
    accept: "تایید",
    check_update: "کنترل بروزسانی",
    no_update_available: "شما در حال حاضر از آخرین نسخه استفاده میکند",
    retry: "دوباره امتحان کن",
    get_ready_file: "...در حال آماده سازی فایل",
    person: "نفر",
    motions: "متحرک",
    static: "ثابت",
    gif: "گیف",
    all_sticker: "همه",
    number_file_attachment: "({{attachment_number}}) فایل آماده ارسال",
    check_NetWorkConnection: "اتصال برقرار نشد، مجددا تلاس کنید",
    today: "امروز",
    yesterday: "دیروز",
  },
  error_boundary: {
    title: "آیگپ با خطا مواجه شد !",
    desc: "خطای پیش بینی نشده ای پیش آمده که منجر به از کار افتادن برنامه شده است. ما از خطای پیش آمده آگاهی داریم و در حال برطرف کردن آن هستیم، تنها کاری که باید انجام دهید کلیک بر روی گزینهٔ «شروع مجدد» است.",
    reset: "بارگذاری مجدد",
  },
  multi_tab: {
    title: "خطا، تب های زیادی یافت شد",
    desc: "آیگپ فقط از یک تب فعال پشتیبانی میکند، لطفاً برای استفاده، این صفحه را ببندید و از تب دیگر استفاده کنید یا همین صفحه را دوباره بارگیری نمایید.",
    cta: "بارگیری صفحه",
  },
  destruction: {
    destruction: "تخریب",
    description: "شما اکنون در حال تلاش برای تخریب اکانت خود هستید، شماره تلفن شما برابر است با :",
    destruction_code: "کد تخریب",
    enter_code: "لطفا کد ارسال شده را وارد کنید",
  },
  info_log: {
    [RoomMessageLog.Type.USER_JOINED]: "{{authorName}} به آیگپ پیوست",
    [RoomMessageLog.Type.USER_DELETED]: "{{authorName}} آیگپ را ترک کرد",
    [RoomMessageLog.Type.ROOM_CREATED]: "{{authorName}} {{roomType}} را ایجاد کرد",
    [RoomMessageLog.Type.MEMBER_ADDED]: "{{targetName}} توسط {{authorName}} به {{roomType}} اضافه شد",
    [RoomMessageLog.Type.MEMBER_KICKED]: "{{targetName}} توسط {{authorName}} از {{roomType}} بیرون انداخته شد",
    [RoomMessageLog.Type.MEMBER_LEFT]: "{{authorName}} {{roomType}} را ترک کرد",
    [RoomMessageLog.Type.ROOM_CONVERTED_TO_PUBLIC]: "{{roomType}} از خصوصی به عمومی تبدیل شد",
    [RoomMessageLog.Type.ROOM_CONVERTED_TO_PRIVATE]: "{{roomType}} از عمومی به خصوصی تبدیل شد",
    [RoomMessageLog.Type.MEMBER_JOINED_BY_INVITE_LINK]: "{{authorName}} با دعوت به {{roomType}} اضافه شد",
    [RoomMessageLog.Type.ROOM_DELETED]: "توسط {{authorName}} حذف شد {{roomType}}",
    [RoomMessageLog.Type.MISSED_VOICE_CALL]: "تماس صوتی از دست رفته",
    [RoomMessageLog.Type.MISSED_VIDEO_CALL]: "تماس تصویری از دست رفته",
    [RoomMessageLog.Type.MISSED_SCREEN_SHARE]: "اشتراک صفحه از دست رفته",
    [RoomMessageLog.Type.MISSED_SECRET_CHAT]: "چت خاتمه یافت",
    [RoomMessageLog.Type.PINNED_MESSAGE]: "پیام پین شد: {{pinnedMessage}}",
    [RoomMessageLog.Type.CHANGE_PHONE_NUMBER]: "شماره خود را تغییر داد {{authorName}}",
  },
  lang: {
    [LocalesType.AR]: "عربى",
    [LocalesType.EN]: "English",
    [LocalesType.FA]: "فارسی",
    title: "زبان",
  },
  news: {
    news_detail: {
      share_news: "اشتراک گذاری خبر",
      your_opinion: "نظر شما چیست ؟",
      no_comments: "هیچ نظری ثبت نشده است",
      comments: "نظرات",
      new_comment_title: "ثبت نظر",
      new_comment_name: "نام",
      new_comment_email: "ایمیل",
      new_comment_comment: "نظر شما",
      new_comment_send: "ثبت",
      new_author_error: "فیلد نام الزامی است",
      new_comment_error: "فیلد نظر الزامی است",
      new_email_error: "فیلد ایمیل الزامی است",
    },
  },

  login: {
    active_code: "کد تایید",
    answer_security_question: "پاسخ سوال امنیتی",
    email: "پست الکترونیک",
    forgot_password: "فراموشی رمز عبور",
    hint: "راهنمای کلمه",
    login: "ورود",
    login_by_mobile: "ورود با شماره موبایل",
    login_by_qrcode: "ورود با اسکن بارکد",
    logout: "خروج",
    delete_account: "حذف حساب کاربری",
    phone_confirm_question: "آیا این شماره را تأیید میکنید؟",
    phone_confirm_title: "تایید شماره موبایل",
    phone_edit: "ویرایش شماره تلفن",
    resend: "ارسال مجدد کد",
    rules_accept: "وارد شدن به آیگپ به منزله پذیرش <1>قوانین\u00a0و\u00a0مقررات</1> است.",
    rules_title: "قوانین و مقررات",
    security_question: "سوال امنیتی",
    send_code: "ارسال کد",
    back_to_account: "بازگشت به آیگپ",
    back_to_login: "بازگشت ",
    resend_recovery_email: "ارسال دوباره ایمیل",
  },
  message_types: {
    undefined: "پیام",
    [RoomMessageType.TEXT]: "متن",
    [RoomMessageType.IMAGE]: "فایل تصویری",
    [RoomMessageType.IMAGE_TEXT]: "فایل تصویری",
    [RoomMessageType.VIDEO]: "فایل ویدیوئی",
    [RoomMessageType.VIDEO_TEXT]: "فایل ویدیوئی",
    [RoomMessageType.AUDIO]: "فایل صوتی",
    [RoomMessageType.AUDIO_TEXT]: "فایل صوتی",
    [RoomMessageType.VOICE]: "فایل ضبط شده",
    [RoomMessageType.GIF]: "فایل گیف",
    [RoomMessageType.GIF_TEXT]: "فایل گیف",
    [RoomMessageType.FILE]: "فایل",
    [RoomMessageType.FILE_TEXT]: "فایل",
    [RoomMessageType.LOCATION]: "آدرس نقشه",
    [RoomMessageType.LOG]: "اعلان",
    [RoomMessageType.CONTACT]: "مخاطب",
    [RoomMessageType.WALLET]: "تراکنش مالی",
    [RoomMessageType.STICKER]: "استیکر",
    [RoomMessageType.STORY_REPLY]: "لحظه",
  },
  messenger_editor: {
    compose_text: "متن ارسالی",
  },
  platforms: {
    [Platform.UNKNOWN_PLATFORM]: "دستگاه ناشناخته",
    [Platform.ANDROID]: "اندروید",
    [Platform.IOS]: "آیفون",
    [Platform.MAC_OS]: "مکینتاش",
    [Platform.WINDOWS]: "ویندوز",
    [Platform.LINUX]: "لینوکس",
    [Platform.BLACK_BERRY]: "بلک بری",
  },
  my_bills: {
    title: "قبض های من",
    phone_number: "شماره تلفن",
    mobile_number: "شماره موبایل",
    total_due_last_term: "مبلغ پایان دوره",
    total_due_mid_term: "مبلغ پایان دوره",
    pay_last_term: "پرداخت پایان دوره",
    pay_mid_term: "پرداخت میان دوره",
    pay: "پرداخت",
    detail: "جزئیات",
    bill_id: "شناسه قبض",
    bill_pay_id: "شناسه پرداخت قبض",
    time_limit: "مهلت پرداخت",
    total_due: "مبلغ",
    branch_info: "اطلاعات انشعاب",
    add_bills_list: "اضافه کردن به لیست قبض های من",
    show_bills_image: "نمایش تصویر قبض",
    edit_bills: "ویرایش قبض",
    bill_info: "اطلاعات قبض",
    bill_detail: "اطلاعات قبض شما",
    bill: "قبض",
  },
  bill_payment: {
    bill_title: "استعلام و پرداخت سریع قبض",
    bill_type: "نوع قبض",
    my_bill: "قبض های من",
    my_electricity_bills: "بررسی قبض",
    service_bills: "قبوض خدماتی",
    phone_bills: "قبوض موبایل و تلفن",
    phone_title: "لطفا شماره تلفن ثابت یا موبایل مورد نظر خود را وارد کنید",
    bills_name: "نام قبض",
    save_changes: "ثبت تغییرات",
    bill: {
      ELECTRICITY: "شناسه قبض",
      MOBILE_MCI: "شماره موبایل",
      PHONE: "شماره تلفن",
      GAS: "کد اشتراک",
    },
  },
  igasht: {
    title: "آیگشت",
    choose_city: "شهر مورد نظر خود را انتخاب کنید",
    search_entertainment: "جستجو مراکز تفریحی",
    location_title: "نقاط تفریحی استان {{city}}",
    founded_location: "{{count}} آیتم یافت شد",
    select_location: "انتخاب محل",
    entertainment: "مراکز تفریحی",
    purchase_code: "کد خرید شما {{code}}",
    purchase_message: "جهت ورود و بازدید بارکد فوق را اسکن کنید",
    purchase_successful: "پرداخت شما با موفقیت انجام شد",
    buy_ticket: {
      finall_credit: "مبلغ نهایی: {{price}} ریال",
      service: "سرویس",
      count: "تعداد",
      price: "قیمت",
      buy_tickets: "خرید بلیط",
      detail: "جزئیات",
    },
  },
  infoAlert: "این عملیات قابل اجرا بر روی نسخه های (ios/android) میباشد.",
  charge_popup: {
    title: "خرید شارژ تلفن همراه",
    buy_charge: "خرید شارژ",
    choose_contact: "انتخاب مخاطبین",
    choose_operator: "انتخاب اپراتور",
    info: "در صورتی که ترابرد کرده اید اپراتور جدید خود را انتخاب کنید",
    previous_purchases: "خرید های قبلی",
    amount: "قیمت",
    discount_plans: "بسته های تخفیف",
    discount_code: "کد تخفیف",
    discount: "تخفیف",
    rials: "ریال",
    enter_discount_code: "کد تخفیف را وارد کنید",
    save_code: "ثبت کد",
    pay: "پرداخت",
    cancel: "انصراف",
    your_score: "اعتبار شما",
    spending_score: "امتیاز مصرفی",
  },
  privacy_popup: {
    account_self_destructs: "خود تخریبی حساب کاربری",
    active_sessions: "نشست های فعال",
    active_sessions_popup: {
      build_version: "نسخه ساخته شده",
      current_session: "دستگاه کنونی شما",
      sessions: "تاریخچه همه نشست ها",
      terminate: "خروج از حساب کاربری",
    },
    after: "پس از",
    allowed_video_call: "افراد مجاز برای تماس تصویری",
    allowed_voice_call: "افراد مجاز برای تماس صوتی",
    blocked_list: "لیست مسدود شده",
    blocked_List_popup: {
      no_blocked_account: "هیچ حسابی وجود ندارد",
      unblock: "خروج از لیست",
    },
    everybody: "همه",
    invite_to_channel: "چه کسی من را به کانال دعوت کند؟",
    invite_to_group: "چه کسی من را به گروه دعوت کند؟",
    last_seen: "آخرین مشاهده",
    my_contacts: "مخاطبین من",
    nobody: "هیچکس",
    privacy: "حریم خصوصی",
    security: "امنیت",
    self_destructs_text: "در صورتی که از حساب کاربری خود در طول یکی از مدت زمان های تعیین شده که به هیچ وجه استفاده نکنید حساب شما پس از آن زمان به صورت خودکار تخریب و برای همیشه حذف می شود",
    two_step: {
      assign_password: "ایجاد کلمه عبور",
      change_hint: "تغییر نشانه رمز عبور",
      change_recovery_email: "تغییر ایمیل بازیابی",
      change_recovery_questions: "تغییر سوالات امنیتی",
      delete_two_step: "حذف رمز عبور دو مرحله ای",
      repeat_password: "تکرار رمز عبور",
      start_text: "متنی در مورد فعالسازی دو مرحله ای",
      verify_recovery_email: "تایید آدرس الکترونیکی",
      email_already_confirmed: "ایمیل وارد شده در حال حاظر همان ایمیل بازیابی شماست",
    },
    two_step_verification: "فعالسازی دو مرحله ای",
    view_profile: "چه کسی تصویر نمایه را ببیند؟",
  },
  contact_popup: {
    title: "اضافه کردن مخاطب جدید",
    edit_contact: "ویرایش مخاطب",
  },
  coming_soon: "به زودی",
  profile_popup: {
    add_account: "افزودن حساب جدید",
    bio: {
      bio: "بیوگرافی",
    },
    display_name: "نام",
    edit_profile: "اطلاعات کاربر",
    email: "پست الکترونیک",
    gender: {
      female: "زن",
      gender: "جنسیت",
      male: "مرد",
    },
    phone: {
      phone: "شماره موبایل",
      invalid_phone: "شماره موبایل نامعتبر است",
      new_phone_identify: "احراز هویت شماره جدید",
      sent_code: "کد ارسال شده",
      invalid_code: "کد وارد شده اشتباه است",
      change_new_phone_successfully: "شماره شما با موفقیت تغییر کرد",
    },
    representative: "کد معرف",
    username: {
      available: "موجود",
      invalid: "نامعتبر",
      taken: "ناموجود",
      username: "نام کاربری",
    },
    failedReq: "{{inputName}} از سرور دریافت نشد",
  },
  room_types: {
    undefined: "چت",
    [Room.Type.CHAT]: "چت",
    [Room.Type.GROUP]: "گروه",
    [Room.Type.CHANNEL]: "کانال",
  },
  sticker_add_popup: "اضافه کردن استیکر",
  room_info_popup: {
    add_member: "افزودن عضو(های) جدید",
    admin_rights: {
      add_admin: "افزودن مدیر",
      admin_rights: "دسترسی های مدیر",
      delete_member: "حذف کاربر",
      post_message: "ارسال پیام",
      edit_message: "ویرایش پیام",
      delete_message: "حذف پیام",
      modify_room: "ویرایش اطلاعات",
      remove_admin: "حذف مدیر",
      sign_messages: "امضا پیام ها",
      reaction_channel: "واکنش در کانال",
      add_Story: "افزودن لحظه ها",
      delete_Story: "حذف لحظه ها",
      show_Story_Views: "نمایش بازدید لحظه ها",
    },
    assign_admin: "تعیین مدیر",
    change_owner: "انتقال مالکیت $t(room_types.{{room}})",
    are_you_sure_change_owner: "آیا از انتقال مالکیت این $t(room_types.{{room}}) به {{user}} مطمئن هستید ؟",
    edit: {
      description: "توضیح مختصر",
      edit_channel: "ویرایش کانال",
      edit_group: "ویرایش گروه",
      name: "نام",
      room_type: "نوع اتاق",
    },
    edit_admin: "ویرایش مدیر",
    leave_channel: "ترک کردن کانال",
    join_channel: "عضو شدن در کانال",
    join_group: "عضو شدن در گروه",
    leave_group: "حذف و ترک گروه",
    block_confirm_message: "آیا از مسدود کردن ارتباط این مخاطب اطینان دارید؟",
    unblock_confirm_message: "آیا از رفع مسدودیت این مخاطب اطمینان دارید؟",
    clear_history_message: "آیا از حدف تاریخچه این گفتگو اطمینان دارید؟",
    member_list: "نمایش اعضا",
    mute_notification: "اطلاع رسانی بیصدا",
    convertToGroup: "تبدیل به گروه",
    permission: {
      add_new_members: "افزودن عضو(های) جدید",
      group_rights: "دسترسی های عمومی گروه",
      member_rights: "ویرایش دسترسی",
      pin_message: "سنجاق پیام",
      send_gif: "ارسال گیف",
      send_link: "ارسال پیوند",
      send_media: "ارسال رسانه",
      send_sticker: "ارسال استیکر",
      send_text: "ارسال متن",
      show_member_list: "نمایش اعضا",
    },
    remove_user: "حذف کاربر",
    report: "گزارش تخلف",
    shared_audio: "صوت های به اشتراک گذاشته شده",
    shared_file: "فایل های به اشتراک گذاشته شده",
    shared_gif: "تصاویر متحرک به اشتراک گذاشته شده",
    shared_image: "تصاویر به اشتراک گذاشته شده",
    shared_media: "رسانه های به اشتراک گذاشته شده",
    shared_url: "پیوندهای به اشتراک گذاشته شده",
    shared_video: "ویدئوهای به اشتراک گذاشته شده",
    shared_voice: "پیام های صوتی به اشتراک گذاشته شده",
  },
  report_reason: {
    [ClientRoomReport.Reason.OTHER]: "دیگر",
    [ClientRoomReport.Reason.SPAM]: "اسپم",
    [ClientRoomReport.Reason.PORNOGRAPHY]: "محتوای جنسی",
    [ClientRoomReport.Reason.VIOLENCE]: "ترویج خشونت",
    [ClientRoomReport.Reason.ABUSE]: "محتوای توهین آمیز و آزاردهنده",
  },
  setting: {
    chat_setting: "تنظیمات صفحه گفتگو",
    data_and_storage: "ذخیره سازی اطلاعات",
    notification: "اعلانات و صدا",
    profile: "اطلاعات کاربر",
    security_and_privacy: "امنیت و حریم خصوصی",
    logout_message: "آیا از خروج حساب کاربری خود اطمینان دارید؟",
  },
  story: {
    deleted: "حذف شده",
    story: "لحظه ها",
    expired: "منقضی شده",
    my_moment: "لحظه من",
    tap_to_add_moment: "برای افزودن لحظه ضربه بزنید",
    recent_updates: "بروزرسانی های اخیر",
    hint: "لحظه های شما پس از ۲۴ ساعت حذف میشوند",
    delete_text: "این لحظه حذف شود ؟‌برای همه کسانی که آن را دریافت کرده اند حذف خواهد شد",
    story_view: "{{storyCount}} بازدید",
    story_viewed_by: "{{storyCount}} دیده شده توسط",
    sending_message: "در حال ارسال پیام...",
    message_sent: "پیام با موفقیت ارسال شد!",
    reply: "پاسخ",
    no_content_title: "لحظه‌هات رو شریک شو!!",
    no_content_desc: "برای اینکه لحظه‌های دوستات رو ببینی یا اینکه لحظه‌هات رو با دوستات شریک بشی، باید گوشی دستت باشه.",
    no_content_button: "دانلود نسخه‌های موبایل آیگپ",
  },
  tabs: {
    [asideTabs.CONTACT]: "مخاطبین",
    [asideTabs.CALL]: "تماس ها",
    [asideTabs.CHAT]: "گفتگو",
    [asideTabs.ILAND]: "آیلند",
    [asideTabs.SETTING]: "نمایه",
    [asideTabs.STORY]: "لحظه ها",
  },
  invite_friends: "سلام! از طریق این لینک میتونی تو آیگپ عضو بشی : https://www.igap.net منتظرتیم , شماره معرف : {{phoneNumber}}",
  validate: {
    accepted: "ورودی باید پذیرفته شده باشد.",
    active_url: "آدرس ورودی معتبر نیست.",
    after: "ورودی باید تاریخی بعد از {{date}} باشد.",
    after_or_equal: "ورودی باید تاریخی بعد از {{date}}، یا مطابق با آن باشد.",
    alpha: "ورودی باید فقط حروف الفبا باشد.",
    alpha_dash: "ورودی باید فقط حروف الفبا، اعداد، خط تیره و زیرخط باشد.",
    alpha_num: "ورودی باید فقط حروف الفبا و اعداد باشد.",
    array: "ورودی باید آرایه باشد.",
    before: "ورودی باید تاریخی قبل از {{date}} باشد.",
    before_or_equal: "ورودی باید تاریخی قبل از {{date}}، یا مطابق با آن باشد.",
    between: {
      array: "ورودی باید بین {{min}} و {{max}} آیتم باشد.",
      file: "ورودی باید بین {{min}} و {{max}} کیلوبایت باشد.",
      numeric: "ورودی باید بین {{min}} و {{max}} باشد.",
      string: "ورودی باید بین {{min}} و {{max}} کاراکتر باشد.",
    },
    boolean: "فیلد ورودی فقط می‌تواند true و یا false باشد.",
    confirmed: "ورودی با فیلد تکرار مطابقت ندارد.",
    date: "ورودی یک تاریخ معتبر نیست.",
    date_equals: "ورودی باید یک تاریخ برابر با تاریخ {{date}} باشد.",
    date_format: "ورودی با الگوی {{format}} مطابقت ندارد.",
    different: "ورودی و {{other}} باید از یکدیگر متفاوت باشند.",
    digits: "ورودی باید {{digits}} رقم باشد.",
    digits_between: "ورودی باید بین {{min}} و {{max}} رقم باشد.",
    dimensions: "ابعاد تصویر ورودی قابل قبول نیست.",
    distinct: "فیلد ورودی مقدار تکراری دارد.",
    email: "ورودی باید یک ایمیل معتبر باشد.",
    ends_with: "فیلد ورودی باید با یکی از مقادیر زیر خاتمه یابد: {{values}}",
    exists: "ورودی انتخاب شده، معتبر نیست.",
    file: "ورودی باید یک فایل معتبر باشد.",
    filled: "فیلد ورودی باید مقدار داشته باشد.",
    gt: {
      array: "ورودی باید بیشتر از {{value}} آیتم داشته باشد.",
      file: "ورودی باید بزرگتر از {{value}} کیلوبایت باشد.",
      numeric: "ورودی باید بزرگتر از {{value}} باشد.",
      string: "ورودی باید بیشتر از {{value}} کاراکتر داشته باشد.",
    },
    gte: {
      array: "ورودی باید بیشتر یا مساوی {{value}} آیتم داشته باشد.",
      file: "ورودی باید بزرگتر یا مساوی {{value}} کیلوبایت باشد.",
      numeric: "ورودی باید بزرگتر یا مساوی {{value}} باشد.",
      string: "ورودی باید بیشتر یا مساوی {{value}} کاراکتر داشته باشد.",
    },
    image: "ورودی باید یک تصویر معتبر باشد.",
    in: "ورودی انتخاب شده، معتبر نیست.",
    in_array: "فیلد ورودی در لیست {{other}} وجود ندارد.",
    integer: "ورودی باید عدد صحیح باشد.",
    ip: "ورودی باید آدرس IP معتبر باشد.",
    ipv4: "ورودی باید یک آدرس معتبر از نوع IPv4 باشد.",
    ipv6: "ورودی باید یک آدرس معتبر از نوع IPv6 باشد.",
    json: "فیلد ورودی باید یک رشته از نوع JSON باشد.",
    length: {
      min: "ورودی باید حداقل {{min}} کاراکتر باشد.",
    },
    lt: {
      array: "ورودی باید کمتر از {{value}} آیتم داشته باشد.",
      file: "ورودی باید کوچکتر از {{value}} کیلوبایت باشد.",
      numeric: "ورودی باید کوچکتر از {{value}} باشد.",
      string: "ورودی باید کمتر از {{value}} کاراکتر داشته باشد.",
    },
    lte: {
      array: "ورودی باید کمتر یا مساوی {{value}} آیتم داشته باشد.",
      file: "ورودی باید کوچکتر یا مساوی {{value}} کیلوبایت باشد.",
      numeric: "ورودی باید کوچکتر یا مساوی {{value}} باشد.",
      string: "ورودی باید کمتر یا مساوی {{value}} کاراکتر داشته باشد.",
    },
    max: {
      array: "ورودی نباید بیشتر از {{max}} آیتم داشته باشد.",
      file: "ورودی نباید بزرگتر از {{max}} کیلوبایت باشد.",
      numeric: "ورودی نباید بزرگتر از {{max}} باشد.",
      string: "ورودی نباید بیشتر از {{max}} کاراکتر داشته باشد.",
    },
    mimes: "فرمت‌های معتبر فایل عبارتند از: {{values}}.",
    mimetypes: "فرمت‌های معتبر فایل عبارتند از: {{values}}.",
    min: {
      array: "ورودی نباید کمتر از {{min}} آیتم داشته باشد.",
      file: "ورودی نباید کوچکتر از {{min}} کیلوبایت باشد.",
      numeric: "ورودی نباید کوچکتر از {{min}} باشد.",
      string: "ورودی نباید کمتر از {{min}} کاراکتر داشته باشد.",
    },
    not_in: "ورودی انتخاب شده، معتبر نیست.",
    not_regex: "فرمت ورودی معتبر نیست.",
    numeric: "ورودی باید عدد یا رشته‌ای از اعداد باشد.",
    password: "رمز عبور اشتباه است.",
    passwordConfirmation: "رمز عبور و تکرار رمز عبور باید یکسان باشند",
    phone: "ورودی باید یک شماره معتبر باشد.",
    present: "فیلد ورودی باید در پارامترهای ارسالی وجود داشته باشد.",
    regex: "فرمت ورودی معتبر نیست.",
    required: "فیلد ورودی الزامی است.",
    required_if: "هنگامی که {{other}} برابر با {{value}} است، فیلد ورودی الزامی است.",
    required_unless: "فیلد ورودی الزامی است، مگر آنکه {{other}} در {{values}} موجود باشد.",
    required_with: "در صورت وجود فیلد {{values}}، فیلد ورودی نیز الزامی است.",
    required_with_all: "در صورت وجود فیلدهای {{values}}، فیلد ورودی نیز الزامی است.",
    required_without: "در صورت عدم وجود فیلد {{values}}، فیلد ورودی الزامی است.",
    required_without_all: "در صورت عدم وجود هر یک از فیلدهای {{values}}، فیلد ورودی الزامی است.",
    same: "ورودی و {{other}} باید همانند هم باشند.",
    size: {
      array: "ورودی باید شامل {{size}} آیتم باشد.",
      file: "ورودی باید برابر با {{size}} کیلوبایت باشد.",
      numeric: "ورودی باید برابر با {{size}} باشد.",
      string: "ورودی باید برابر با {{size}} کاراکتر باشد.",
    },
    starts_with: "ورودی باید با یکی از این ها شروع شود: {{values}}",
    string: "فیلد ورودی باید متن باشد.",
    timezone: "فیلد ورودی باید یک منطقه زمانی معتبر باشد.",
    unique: "ورودی قبلا انتخاب شده است.",
    uploaded: "بارگذاری فایل ورودی موفقیت آمیز نبود.",
    url: "ورودی معتبر نمی‌باشد.",
    uuid: "ورودی باید یک UUID معتبر باشد.",
  },
  wallet: {
    bill_id: "شناسه قبض",
    bill_type: "نوع قبض",
    card_number: "شماره کارت",
    card_owner: "صاحب کارت",
    cardToCardInvoiceNumber: "شماره صورت حساب",
    charger_mobile_number: "شماره موبایل شارژ شونده",
    description: "توضیحات",
    destination_bank: "بانک مقصد",
    destination_card: "کارت مقصد",
    pec_qr: "کیف پول",
    header: {
      [RoomMessageWallet.Type.MONEY_TRANSFER]: "انتقال وجه",
      [RoomMessageWallet.Type.PAYMENT]: "پرداخت",
      [RoomMessageWallet.Type.CARD_TO_CARD]: "انتقال وجه کارت به کارت",
      [RoomMessageWallet.Type.TOPUP]: "خرید شارژ",
      [RoomMessageWallet.Type.BILL]: "پرداخت قبض",
    },
    order_id: "شماره سفارش",
    pay_id: "شناسه پرداخت",
    requester_mobile_number: "شماره موبایل درخواست دهنده",
    rrn: "شماره مرجع",
    source_bank: "بانک مبدا",
    source_card: "کارت مبدا",
    terminal_No: "شماره پایانه",
    topup_type: "نوع شارژ",
    topup_types: {
      [RoomMessageWallet.Topup.Type.IRANCELL_PREPAID]: "ایرانسل دائمی",
      [RoomMessageWallet.Topup.Type.IRANCELL_WOW]: "ایرانسل شگفت انگیز",
      [RoomMessageWallet.Topup.Type.IRANCELL_WIMAX]: "ایرانسل وایمکس",
      [RoomMessageWallet.Topup.Type.IRANCELL_POSTPAID]: "ایرانسل اعتباری",
      [RoomMessageWallet.Topup.Type.MCI]: "همراه اول",
      [RoomMessageWallet.Topup.Type.RIGHTEL]: "رایتل",
    },
    trace_number: "کد پیگیری",
    wallet_amount: "مبلغ",
    wallet_from: "از",
    wallet_to: "به",
    wallet_amount_label: "مبلغ را وارد کنید",
    wallet_qrCode_label: "کد را وارد کنید",
  },
  welcome_futures: {
    "1": {
      content:
        "آیگپ یک ارتباط امن و مطمئن را برای شما برقرار میکند. پیام رسان آیگپ با استفاده از الگوریتم های رمزنگاری منحصربفرد در جابجایی همه داده های شما حداکثر امنیت را برای حفظ حریم خصوصی شما فراهم آورده است.",
      title: "امنیت در آیگپ",
    },
    "2": {
      content: "ایلند! سرزمین بی حد و مرز که کلی اتفاق شگفت انگیز مثل گرفتن تاکسی، الوپیک، پرداخت قبض و رزرو تور و هتل توش افتاده. و تازه میتونی کلی بازی کنی، فیلم ببینی و موزیک گوش بدی.",
      title: "آیلند",
    },
    "3": {
      content: "با اطراف من پا به دنیای جدید بگذارید. در اطرافتان دوستان خود، مراکز تفریحی، هنری، تجاری و ... را پیدا کنید و از لحظه های خود لذت ببرید...",
      title: "اطراف من",
    },
    "4": {
      content:
        "شما میتوانید در آیگ بصورت دو نفره و یا گروهی به گفتگو بپردازید و خیالتان راحت باشد که همیشه به گفتگو های خود دسترسی دارید، همچنین میتوانید کانال بسازید و در آن عضو بگیرید و اطلاعات خود را بین میلیون ها کاربر دیگر نیز به اشتراک بگزارید.",
      title: "گفتگو در آیگپ",
    },
  },
  search: {
    chats: "چت ها",
    contacts: "مخاطبین",
    channels: "کانال ها",
    messages: "پیام ها",
    groups: "گروه ها",
    titles: {
      mine: "چت ها و مخاطبین",
      global: "جستجوی سراسری",
    },
  },
  notification_popup: {
    title_alert: "تنظیمات اعلانات",
    sound: "پخش صدا",
    preview: "پیش نمایش پیام",
    disable: "هشدار",
    default_message: "یک پیام جدید برای شما ارسال شده است",
  },
  update_popup: {
    title: "بروزرسانی",
    new_version_available: "نسخه جدیدی از برنامه موجود است , بروزرسانی انجام شود ؟",
    yes: "بلی",
    no: "فعلا نه",
  },
  username_popup: {
    title: "تغییر نام کاربری",
    field: "نام کاربری جدید : ",
  },
  convertToGroup_popup: {
    title: "تبدیل به گروه",
    name: "نام گروه",
    description: "توضیخات گروه",
    accept: "ایجاد گروه",
  },
  roadmap: {
    title: "آخرین به روز رسانی : {{date}}",
    button: "ورود به نسخه وب جدید",
    [RoadmapDataType.TODO]: "امکاناتی که در آینده پیاده سازی خواهیم کرد...",
    [RoadmapDataType.DOING]: "امکاناتی که در حال پیاده سازی آنها هستیم",
    [RoadmapDataType.DONE]: "امکاناتی که به تازگی پیاده سازی کردیم !",
  },
  popup_receipt: {
    title: "پیش فاکتور خرید اینترنتی",
    final: "مبلغ نهایی",
    coupon_notvalid: "کد تخفیف وارد شده معتبر نمیباشد",
    discount: "میزان تخفیف : ",
    score_spent: "میزان کسر امتیاز",
  },
  popup_gift_sticker: {
    info: "شما در حال ارسال استیکر هدیه هستید",
    title: "خرید کارت هدیه دیجیتال",
    submit_button: "استعلام و خرید",
    my_cards: "کارت های هدیه من",
    cards_NEW: "قابل استفاده",
    cards_FORWARDED: "ارسال شده",
    cards_ACTIVE: "فعال شده",
    activated_cards: "کارت هدیه دیجیتال فعال شده",
    status_PENDING: "در حال ارسال...",
    status_SUCCESS: "استعلام کد ملی با موفقیت انجام شد",
    status_WRONG: "کد ملی و شماره شما با یکدیگر همخوانی ندارند",
    status_ERROR: "مشکلی پیش آمده لطفا فیلد ها را بررسی و مجددا تلاش نمایید",
    final_success: "فعالسازی کارت هدیه با موفقیت انجام شد و از قسمت استیکر های اهای هدیه در آیلند قابل مدیریت میباشد",
    final_error: "هنگام فعالسازی کارت هدیه مشکلی پیش آمده لطفا مججدا تلاش نمایید یا با پشتیبانی ارتباط برقرار نمایید",
  },
  popup_a2HS: {
    title: "افزودن وب اپلیکیشن آیگپ",
    share_button: "1- دکمه share را در نوار پایین کلیلک کنید",
    add_2hs: "2- گزینه Add to Home... را انتخاب کنید",
    add_hs: "3- در قسمت بالا روی Add کلیک کنید",
    add: "Add",
    close: "بستن",
  },
  popup_buy_data: {
    title: "خرید بسته اینترنتی",
    special_packages: "بسته های ویژه",
    nonSpecial_packages: "همه بسته ها",
    list_titles: {
      [internetPackageEnum.Credit]: "بسته اعتباری",
      [internetPackageEnum.Permanent]: "بسته دائمی",
      [internetPackageEnum.CreditPermanent]: "بسته اعتباری و دائمی",
      [internetPackageEnum.CreditTdLte]: "بسته TD-LTE اعتباری",
      [internetPackageEnum.Permanent_Td_Lte]: "بسته TD-LTE دائمی",
      [internetPackageEnum.Data]: "دیتا",
    },
    package_type: {
      [internetPackageTypes.Time]: "زمان دار",
      [internetPackageTypes.Volume]: "حجمی",
    },
  },
  popup_financial_history: {
    title: "فهرست تراکنش ها",
    order_id: "شناسه پرداخت",
    success_payment: "پرداخت موفق",
    failure_payment: "پرداخت ناموفق",
    fields: {
      billId: "شناسه قبض",
      billtype: "نوع قبض",
      cardnumber: "شماره کارت",
      merchantname: "نام پذیرنده",
      payid: "شناسه پرداخت",
      amount: "مبلغ (ریال)",
      orderid: "شماره سفارش",
      rrn: "شماره مرجع",
      terminalno: "شماره پایانه",
      traceno: "شماره پیگیری",
      bankname: "بانک",
      cardownername: "صاحب کارت",
      destbankname: "بانک مقصد",
      destcardnumber: "کارت مقصد",
      sourcecardnumber: "کارت مبدا",
    },
    transaction_type: {
      [MplTransaction.Type.BILL]: "قبض و جریمه",
      [MplTransaction.Type.CARD_TO_CARD]: "کارت به کارت",
      [MplTransaction.Type.NONE]: "همه",
      [MplTransaction.Type.SALES]: "پرداخت اینترنتی",
      [MplTransaction.Type.TOPUP]: "شارژ موبایل",
    },
  },
  popup_inquiry: {
    prefix_example: "مثلا : 021",
    phone_example: "مثلا : 44567899",
    error_number: "شماره وارد شده اشتباه است",
    last_term: "پایان دوره",
    mid_term: "میان دوره",
    billId: "شناسه قبض",
    payId: "شناسه پرداخت",
    amount: "مبلغ (ریال)",
  },
};

export default fa;
